import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterRatingSearchValueObject extends ValueObject {
  #rating

  constructor({rating}) {
    super()
    this.#rating = rating
  }

  static create({rating}) {
    return new FilterRatingSearchValueObject({rating: FilterRangeSearchValueObject.create(rating)})
  }

  static createWithDefaultValue({config, rating}) {
    const {DEFAULT_RATING_SEARCH} = config.get('searchFilters')

    return new FilterRatingSearchValueObject({
      rating: FilterRangeSearchValueObject.create({
        from: rating?.from || DEFAULT_RATING_SEARCH.from,
        to: rating?.to || DEFAULT_RATING_SEARCH.to
      })
    })
  }

  static createQueryParams({config, rating}) {
    const {DEFAULT_RATING_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterRatingSearchValueObject({
      rating: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.RATING].from,
          value: rating?.from || DEFAULT_RATING_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.RATING].to,
          value: rating?.to || DEFAULT_RATING_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#rating.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#rating.from.isEmpty && {...this.#rating.from.queryParam}),
      ...(!this.#rating.to.isEmpty && {...this.#rating.to.queryParam})
    }
  }

  get value() {
    return this.#rating.value
  }

  toJSON() {
    return {
      rating: this.#rating.toJSON()
    }
  }
}
